import { PDRHistoryDetailsData } from "./[activityId]/types";

export const formatPDRHistoryDetailsForForm = (data: PDRHistoryDetailsData | undefined, pgaId: string) => {
  return {
    activityCode: data?.pdrHistoryDetails?.activityCode,
    activityType: data?.pdrHistoryDetails?.category,
    person: pgaId,
    title: data?.pdrHistoryDetails?.description1 || "",
    activityDescription: data?.pdrHistoryDetails?.description2 || "",
    totalHours: data?.pdrHistoryDetails?.creditsAppliedFor || "",
    creditsRequested: data?.pdrHistoryDetails?.creditsAppliedFor || "",
    creditsAwarded: data?.pdrHistoryDetails?.creditsAccepted || "",
    publishedAt: data?.pdrHistoryDetails?.participationDates?.startedOn || "",
    startDate: data?.pdrHistoryDetails?.participationDates?.startedOn || "",
    endDate: data?.pdrHistoryDetails?.participationDates?.endedOn || "",
    location: data?.pdrHistoryDetails?.location || ""
  };
};

export const excludedActivityCodes = (activityCode: string | null) =>
  !["M06", "M09", "M07"].includes(activityCode || "");
